import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import AntButton from "antd/es/button";
import classnames from "../../utils/classnames.js";
import './Button.css';/* empty css            */
const Button = ({
  children,
  className,
  icon,
  type = "primary",
  fullWidth = "xs",
  iconPosition = "right",
  iconGapSize = "normal",
  directionalWrap = true,
  ...props
}) => {
  const Icon = useMemo(() => {
    if (!icon) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-button__icon"), children: icon });
  }, [icon]);
  return /* @__PURE__ */ jsx(
    AntButton,
    {
      icon: Icon,
      className: classnames(
        [
          "perxis-auto-button",
          `perxis-auto-button-${type}`,
          {
            [`perxis-auto-button--with-icon`]: Icon,
            [`perxis-auto-button--icon-position-${iconPosition}`]: Icon,
            [`perxis-auto-button--icon-gap-${iconGapSize}`]: Icon && children,
            [`perxis-auto-button--full-width-${fullWidth}`]: fullWidth,
            [`perxis-auto-button--icon-only`]: !children
          }
        ],
        className
      ),
      ...props,
      children: directionalWrap ? /* @__PURE__ */ jsx("bdi", { children }) : children
    }
  );
};
export {
  Button as default
};
//# sourceMappingURL=Button.js.map
